import React from 'react';
import { Shield, AlertTriangle, Users, Clock } from 'lucide-react';
import './shared-analytics.css';

const CriticalAnalytics = () => {
  return (
    <div className="critical-analytics">
      <div className="analytics-summary">
        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#fef2f2', color: '#dc2626' }}>
            <Shield size={24} />
          </div>
          <div className="card-content">
            <h3>Critical Patients</h3>
            <div className="card-value">2</div>
            <div className="card-change negative">Immediate attention</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#fffbeb', color: '#f59e0b' }}>
            <AlertTriangle size={24} />
          </div>
          <div className="card-content">
            <h3>At Risk</h3>
            <div className="card-value">5</div>
            <div className="card-change neutral">Monitor closely</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#eff6ff', color: '#3b82f6' }}>
            <Users size={24} />
          </div>
          <div className="card-content">
            <h3>Low Adherence</h3>
            <div className="card-value">8</div>
            <div className="card-change neutral">&lt;50% compliance</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#f0f9ff', color: '#0891b2' }}>
            <Clock size={24} />
          </div>
          <div className="card-content">
            <h3>Avg. Response Time</h3>
            <div className="card-value">2.4h</div>
            <div className="card-change positive">-30min improvement</div>
          </div>
        </div>
      </div>

      <div className="content-placeholder">
        <h3>Critical Patient Monitoring</h3>
        <p>High-risk patient identification and intervention tracking.</p>
        <ul>
          <li>Real-time critical patient alerts</li>
          <li>Risk factor identification</li>
          <li>Intervention effectiveness tracking</li>
          <li>Escalation protocols</li>
          <li>Follow-up scheduling</li>
        </ul>
      </div>
    </div>
  );
};

export default CriticalAnalytics;



